export default __webpack_public_path__ + "static/media/01.b69fd532.jpg";